export default "__VITE_ASSET__BPIr_RpS__"